import React, { useEffect, useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import TagService from "../../../services/TagService";
import { TagTypeText } from "../../../enums/tagTypes";
import { TagTypeIcons } from "../../../utils/tagTypeIcons";
import LicenseService from "../../../services/LicensesService";
import { Copy } from "../../../components/Copy/Copy";

const ListDiscountReasons = (props) => {
   const [discountReasons, setDiscountReasons] = useState([]);
   const [maxPage, setMaxPage] = useState(1);
   const [currentPage, setCurrentPage] = useState(1);
   const { user } = useAuth();
   const [collumnClicked, setCollumnClicked] = useState({
      collumnTitle: "level",
      orderDirection: "ASC",
   });
   const [isLoading, setIsLoading] = useState(true);

   const getDiscountReasons = async (page, searchText, collumnClicked) => {
      setIsLoading(true);
      const response =
         await LicenseService.getPaginatedDiscountReasons(
            page,
            searchText,
            collumnClicked
         );
      setDiscountReasons(response.data.items);
      setMaxPage(response.data.pagination.totalPages);
      setIsLoading(false);
   };

   useEffect(() => {
      getDiscountReasons(currentPage, props.filters, collumnClicked);
   }, [
      user,
      currentPage,
      props.filters,
      collumnClicked,
      props.refreshKey
   ]);

   return (
      <>
         <div className="list-container list-visibility">
            <List
               isLoading={isLoading}
               handleCollumnTitleClick={(collumnIndex) =>
                  setCollumnClicked(collumnIndex)
               }
               collumsObjIndex={[
                  {
                     collumnLabel: "Nome",
                     index: "name",
                     type: "text",
                  },
                  {
                     collumnLabel: "Código",
                     index: "code",
                     type: "custom",
                     custom: ({ row }) => {
                        return (
                           <Copy text={row.code} showText={true} onClick={(e) => e.stopPropagation()} />
                        );
                     }
                  },
               ]}
               data={discountReasons}
            />
         </div>
         <div className="card-visibility">
            {discountReasons &&
               discountReasons.map((discountReason, index) => (
                  <Card
                     key={index}
                     data={discountReason}
                     image={profileAvatar}
                     delete={() => LicenseService.deleteDiscountReason(discountReason.id)}
                     navigateOnDelete={"/licenses/discount-reasons"}
                     navigateOnEdit={"/licenses/discount-reasons"}
                     askForPasswordOnDelete={true}
                  >
                     <p className="card-content-title">{discountReason.name}</p>
                  </Card>
               ))}
         </div>
         <Pagination
            rowsPerPage={50}
            maxPage={maxPage}
            changePage={(page) =>
               setCurrentPage(page)
            }
         />
      </>
   );
};

export default ListDiscountReasons;